import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history/19th_Century_-_Unification_of_Germany_and_Italy.png';

function HistoryPageUnificationGermanyItaly() {
  return (
    <TopicPage
      topicKey="Unification of Germany and Italy"
      title="History: Unification of Germany and Italy"
      backgroundImage={bg}
      startRoute="/History-Unification-Germany-Italy-Go"
      scrollLabels={[
        "Rise of Nationalism",
        "Otto von Bismarck and Prussia",
        "Italian Unification and Garibaldi",
      ]}
      backRoute="/history-19th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageUnificationGermanyItaly;
